import React from 'react';
import './NavigationBar.css';
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { canSeePage, pageName } from '../../roleAccess';

// All icons unified to FontAwesome 5 for visual consistency. Previous
// reportsIcon (029-logistics.gif) and tankIcon (020-gas-station.png) were
// retired so all nav entries share the same line-icon style.
const NAV_ICON_STYLE = { fontSize: '50px', color: '#364954' };

// Card-manager identity gating — must match the constant in App.js + Cards.js.
// Card-manager sees ONLY the Cards icon; everyone else sees everything except.
const CARD_MANAGER_EMAIL = 'card@manager.com';

export const NavigationBar = (props) => {

  const location = useLocation();

  // Read email from sessionStorage directly so we don't need to thread `token`
  // through the existing NavigationBar props. Falls back gracefully when the
  // user isn't logged in or the token shape is unexpected.
  const sessionToken = (() => {
    try { return JSON.parse(sessionStorage.getItem('token') || 'null'); }
    catch { return null; }
  })();
  const userEmail = sessionToken?.data?.user_record?.email || '';
  const isCardManager = userEmail === CARD_MANAGER_EMAIL;

  // The token's data object (carries user_record.roles.id). Page visibility is
  // decided by the central map in components/roleAccess.js. Card-manager is a
  // separate identity (SuperAdmin role server-side) so it keeps its own gate.
  const user = sessionToken?.data;
  const can = (key) => !isCardManager && canSeePage(user, key);

  /*const LogoutTimeout = () => {

    const [logoutState, setLogoutState] = useState();
    fetch(`https://${sessionStorage.getItem("ReaderIp")}/v1/authentication/refresh`, 
    {
      headers: { 'Authorization': props.token.access_token },
    })
    .then(response => response.json())
    .then(data => setLogoutState(data.data.refresh_token))
    
  if(!state) {
    alert("Session Timed Out");
    sessionStorage.clear();
    window.location.reload(false);
  }}
  
  setInterval(LogoutTimeout, 5000);*/

return (
  <div className="NavBarIcons" hidden={props.viewMenusState}>

    {can('Statistics') && (
    <Link to="/Statistics" onClick={props.LogoutTimeout} className="NavIcons" id={location.pathname === '/Statistics' ? 'WithBackground' : 'WithoutBackground'} style={{ textDecorationColor: '#ff624b' }}>
    <i className="fas fa-chart-line" style={NAV_ICON_STYLE}></i>
    <p className="NavIconsText">{pageName('Statistics', 'DASHBOARD')}</p>
  </Link>
 )}

    {can('StationMap') && (
    <Link to="/StationMap" onClick={props.LogoutTimeout} className="NavIcons" id={location.pathname === '/StationMap' ? 'WithBackground' : 'WithoutBackground'} style={{ textDecorationColor: '#ff624b' }}>
      <i className="fas fa-map-marked-alt" style={NAV_ICON_STYLE}></i>
      <p className="NavIconsText">{pageName('StationMap', 'STATION MAP')}</p>
    </Link>
    )}

    {can('Reports') && (
    <Link to="/Reports" onClick={() => {if (location.pathname !== '/Reports' && props.showFilterFields === "block"){props.setShowFilterState();} if (location.pathname !== '/Reports' && props.showReportsCheckboxes === "block"){props.setReportsCheckboxesState();}props.LogoutTimeout();}} className="NavIcons" id={location.pathname === '/Reports' ? 'WithBackground' : 'WithoutBackground'} style={{ textDecorationColor: '#ff624b' }}>
      <i className="fas fa-file-alt" style={NAV_ICON_STYLE}></i>
      <p className="NavIconsText">{pageName('Reports', 'TRA RECEIPTS')}</p>
    </Link>
    )}

    {can('PeriodicReports') && (
    <Link to="/PeriodicReports" onClick={() => {if (location.pathname !== '/PeriodicReports' && props.showFilterFields === "block"){props.setShowFilterState();} if (location.pathname !== '/PeriodicReports' && props.showReportsCheckboxes === "block"){props.setReportsCheckboxesState();}props.LogoutTimeout();}} className="NavIcons" id={location.pathname === '/PeriodicReports' ? 'WithBackground' : 'WithoutBackground'} style={{ textDecorationColor: '#ff624b' }}>
      <i className="fas fa-calendar-alt" style={NAV_ICON_STYLE}></i>
      <p className="NavIconsText">{pageName('PeriodicReports', 'PERIODIC REPORTS')}</p>
    </Link>
    )}

    {can('CloseReports') && (
    <Link to="/CloseReports" onClick={() => {if (location.pathname !== '/CloseReports' && props.showFilterFields === "block"){props.setShowFilterState();} if (location.pathname !== '/CloseReports' && props.showReportsCheckboxes === "block"){props.setReportsCheckboxesState();}props.LogoutTimeout();}} className="NavIcons" id={location.pathname === '/CloseReports' ? 'WithBackground' : 'WithoutBackground'} style={{ textDecorationColor: '#ff624b' }}>
      <i className="fas fa-clipboard-check" style={NAV_ICON_STYLE}></i>
      <p className="NavIconsText">{pageName('CloseReports', 'CLOSE REPORTS')}</p>
    </Link>
    )}

    {can('OffloadingReports') && (
    <Link to="/OffloadingReports" onClick={() => {if (location.pathname !== '/OffloadingReports' && props.showFilterFields === "block"){props.setShowFilterState();} if (location.pathname !== '/OffloadingReports' && props.showReportsCheckboxes === "block"){props.setReportsCheckboxesState();}props.LogoutTimeout();}} className="NavIcons" id={location.pathname === '/OffloadingReports' ? 'WithBackground' : 'WithoutBackground'} style={{ textDecorationColor: '#ff624b' }}>
      <i className="fas fa-truck" style={NAV_ICON_STYLE}></i>
      <p className="NavIconsText">{pageName('OffloadingReports', 'OFFLOADING REPORTS')}</p>
    </Link>
    )}

    {can('TankGauge') && (
    <Link to="/TankGauge" onClick={props.LogoutTimeout} className="NavIcons" id={location.pathname === '/TankGauge' ? 'WithBackground' : 'WithoutBackground'} style={{ textDecorationColor: '#ff624b' }}>
      <i className="fas fa-database" style={NAV_ICON_STYLE}></i>
      <p className="NavIconsText">{pageName('TankGauge', 'ATG')}</p>
    </Link>
    )}

    {isCardManager && (
    <Link to="/Cards" onClick={props.LogoutTimeout} className="NavIcons" id={location.pathname === '/Cards' ? 'WithBackground' : 'WithoutBackground'} style={{ textDecorationColor: '#ff624b' }}>
      <i className="fas fa-id-card" style={NAV_ICON_STYLE}></i>
      <p className="NavIconsText"> {pageName('Cards', 'CARDS')}</p>
    </Link>
    )}

    {isCardManager && (
    <Link to="/AttendantCards" onClick={props.LogoutTimeout} className="NavIcons" id={location.pathname === '/AttendantCards' ? 'WithBackground' : 'WithoutBackground'} style={{ textDecorationColor: '#ff624b' }}>
      <i className="fas fa-id-badge" style={NAV_ICON_STYLE}></i>
      <p className="NavIconsText">{pageName('AttendantCards', 'ATTENDANT CARDS')}</p>
    </Link>
    )}

    {can('Settings') && (
    <Link to="/Settings" onClick={props.LogoutTimeout} className="NavIcons" id={location.pathname === '/Settings' ? 'WithBackground' : 'WithoutBackground'} style={{ textDecorationColor: '#ff624b' }}>
      {/* The gas-pump glyph is asymmetric (body left, hose juts right) so a
          plain centered box reads as shifted left. Nudge it right a touch to
          visually centre the pump body over the title. */}
      <i className="fas fa-gas-pump" style={{ ...NAV_ICON_STYLE, transform: 'translateX(4px)' }}></i>
      <p className="NavIconsText">{pageName('Settings', 'STATIONS')}</p>
    </Link>
    )}

    {can('Users') && (
    <Link to="/Users" onClick={props.LogoutTimeout} className="NavIcons" id={location.pathname === '/Users' ? 'WithBackground' : 'WithoutBackground'} style={{ textDecorationColor: '#ff624b' }}>
      {/* fa-users (symmetric group) centres cleanly; fa-user-plus leaned left
          because the "+" hangs off the right. */}
      <i className="fas fa-users" style={NAV_ICON_STYLE}></i>
      <p className="NavIconsText">{pageName('Users', 'USERS')}</p>
    </Link>
    )}
    {can('Cards') && (
    <Link to="/Cards" onClick={props.LogoutTimeout} className="NavIcons" id={location.pathname === '/Cards' ? 'WithBackground' : 'WithoutBackground'} style={{ textDecorationColor: '#ff624b' }}>
     <i className="fas fa-credit-card" style={NAV_ICON_STYLE}></i>
     <p className="NavIconsText">{pageName('Cards', 'CLIENT CARDS')}</p>
    </Link>
    )}

    {can('AttendantCards') && (
    <Link to="/AttendantCards" onClick={props.LogoutTimeout} className="NavIcons" id={location.pathname === '/AttendantCards' ? 'WithBackground' : 'WithoutBackground'} style={{ textDecorationColor: '#ff624b' }}>
      <i className="fas fa-id-badge" style={NAV_ICON_STYLE}></i>
      <p className="NavIconsText">{pageName('AttendantCards', 'ATTENDANT CARDS')}</p>
    </Link>
    )}

    {can('Orders') && (
    <Link to="/Orders" onClick={props.LogoutTimeout} className="NavIcons" id={location.pathname === '/Orders' ? 'WithBackground' : 'WithoutBackground'} style={{ textDecorationColor: '#ff624b' }}>
      <i className="fas fa-qrcode" style={NAV_ICON_STYLE}></i>
      <p className="NavIconsText">{pageName('Orders', 'ORDERS')}</p>
    </Link>
    )}

    {can('BusesReports') && (
    <Link to="/BusesReports" onClick={props.LogoutTimeout} className="NavIcons" id={location.pathname === '/BusesReports' ? 'WithBackground' : 'WithoutBackground'} style={{ textDecorationColor: '#ff624b' }}>
      <i className="fas fa-bus" style={NAV_ICON_STYLE}></i>
      <p className="NavIconsText">{pageName('BusesReports', 'Buses Manager')}</p>
    </Link>
    )}

  </div>
);}